/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { BriefType } from './';
import {
    BriefTypeFromJSON,
    BriefTypeFromJSONTyped,
    BriefTypeToJSON,
} from './';
import type { Criterion } from './';
import {
    CriterionFromJSON,
    CriterionFromJSONTyped,
    CriterionToJSON,
} from './';
import type { Duration } from './';
import {
    DurationFromJSON,
    DurationFromJSONTyped,
    DurationToJSON,
} from './';
import type { Finance } from './';
import {
    FinanceFromJSON,
    FinanceFromJSONTyped,
    FinanceToJSON,
} from './';
import type { Profile } from './';
import {
    ProfileFromJSON,
    ProfileFromJSONTyped,
    ProfileToJSON,
} from './';
import type { ProjectDescription } from './';
import {
    ProjectDescriptionFromJSON,
    ProjectDescriptionFromJSONTyped,
    ProjectDescriptionToJSON,
} from './';
import type { ProjectTitle } from './';
import {
    ProjectTitleFromJSON,
    ProjectTitleFromJSONTyped,
    ProjectTitleToJSON,
} from './';
import type { StartDate } from './';
import {
    StartDateFromJSON,
    StartDateFromJSONTyped,
    StartDateToJSON,
} from './';
import type { WorkConditions } from './';
import {
    WorkConditionsFromJSON,
    WorkConditionsFromJSONTyped,
    WorkConditionsToJSON,
} from './';

/**
 * 
 * @export
 * @interface BriefResource
 */
export interface BriefResource {
    /**
     * 
     * @type {string}
     * @memberof BriefResource
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BriefResource
     */
    identityId: string;
    /**
     * 
     * @type {string}
     * @memberof BriefResource
     */
    companyId: string;
    /**
     * 
     * @type {Date}
     * @memberof BriefResource
     */
    creationDate: Date;
    /**
     * 
     * @type {ProjectTitle}
     * @memberof BriefResource
     */
    title: ProjectTitle;
    /**
     * 
     * @type {BriefType}
     * @memberof BriefResource
     */
    type: BriefType;
    /**
     * 
     * @type {ProjectDescription}
     * @memberof BriefResource
     */
    description: ProjectDescription;
    /**
     * 
     * @type {Duration}
     * @memberof BriefResource
     */
    duration: Duration;
    /**
     * 
     * @type {Finance}
     * @memberof BriefResource
     */
    finance: Finance;
    /**
     * 
     * @type {WorkConditions}
     * @memberof BriefResource
     */
    workConditions: WorkConditions;
    /**
     * 
     * @type {StartDate}
     * @memberof BriefResource
     */
    startDate: StartDate;
    /**
     * 
     * @type {Profile}
     * @memberof BriefResource
     */
    profile: Profile;
    /**
     * 
     * @type {Array<Criterion>}
     * @memberof BriefResource
     */
    refinementCriteria: Array<Criterion>;
    /**
     * 
     * @type {number}
     * @memberof BriefResource
     */
    numberOfFreelancersNeeded?: number;
}

/**
 * Check if a given object implements the BriefResource interface.
 */
export function instanceOfBriefResource(value: object): value is BriefResource {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('identityId' in value) || value['identityId'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('creationDate' in value) || value['creationDate'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('duration' in value) || value['duration'] === undefined) return false;
    if (!('finance' in value) || value['finance'] === undefined) return false;
    if (!('workConditions' in value) || value['workConditions'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('profile' in value) || value['profile'] === undefined) return false;
    if (!('refinementCriteria' in value) || value['refinementCriteria'] === undefined) return false;
    return true;
}

export function BriefResourceFromJSON(json: any): BriefResource {
    return BriefResourceFromJSONTyped(json, false);
}

export function BriefResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): BriefResource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'identityId': json['identityId'],
        'companyId': json['companyId'],
        'creationDate': (new Date(json['creationDate'])),
        'title': ProjectTitleFromJSON(json['title']),
        'type': BriefTypeFromJSON(json['type']),
        'description': ProjectDescriptionFromJSON(json['description']),
        'duration': DurationFromJSON(json['duration']),
        'finance': FinanceFromJSON(json['finance']),
        'workConditions': WorkConditionsFromJSON(json['workConditions']),
        'startDate': StartDateFromJSON(json['startDate']),
        'profile': ProfileFromJSON(json['profile']),
        'refinementCriteria': ((json['refinementCriteria'] as Array<any>).map(CriterionFromJSON)),
        'numberOfFreelancersNeeded': json['numberOfFreelancersNeeded'] == null ? undefined : json['numberOfFreelancersNeeded'],
    };
}

export function BriefResourceToJSON(value?: BriefResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'identityId': value['identityId'],
        'companyId': value['companyId'],
        'creationDate': ((value['creationDate']).toISOString()),
        'title': ProjectTitleToJSON(value['title']),
        'type': BriefTypeToJSON(value['type']),
        'description': ProjectDescriptionToJSON(value['description']),
        'duration': DurationToJSON(value['duration']),
        'finance': FinanceToJSON(value['finance']),
        'workConditions': WorkConditionsToJSON(value['workConditions']),
        'startDate': StartDateToJSON(value['startDate']),
        'profile': ProfileToJSON(value['profile']),
        'refinementCriteria': ((value['refinementCriteria'] as Array<any>).map((v) => CriterionToJSON(v))),
        'numberOfFreelancersNeeded': value['numberOfFreelancersNeeded'],
    };
}

